import blue from "./blue.jsx";
import red from "./red.jsx";
import wood from "./wood.jsx";
import metal from "./iron.jsx";

export default {
  blue,
  red,
  wood,
  iron: metal,
};
